import React from 'react';
import '../App.css';
import 'bootstrap/dist/css/bootstrap.css';

export default class CookiesPolicy extends React.Component {
    render() {
      return (
        <div>
          <div className="jumbotron">
            <div className="container">
              <h1>Cookies Policy</h1>
            </div>
          </div>
          <div className="container">
            <p>We use cookies on https://pametno-mesto2.herokuapp.com (the "Service"). By using the Service, you consent to the use of cookies.</p>
            <p>Our Cookies Policy explains what cookies are, how we use cookies, how third-parties we may partner with may use cookies on the Service, your choices regarding cookies and further information about cookies.</p>
            <h4>What are cookies</h4>
            <p>Cookies are small pieces of text sent by your web browser by a website you visit. A cookie file is stored in your web browser and allows the Service or a third-party to recognize you and make your next visit easier and the Service more useful to you.</p>
            <p>Cookies can be "persistent" or "session" cookies.</p>
            <h4>How we use cookies</h4>
            <p>When you use and access the Service, we may place a number of cookies files in your web browser.</p>
            <p>We use cookies for the following purposes: to enable certain functions of the Service, to provide authentification.</p>
            <p>We use session cookies: </p>
            <p>- Essential cookies. We use essential cookies to authenticate users and prevent fraudulent use of user accounts.</p>
            <h4>Third-party cookies</h4>
            <p>In addition to our own cookies, we may also use various third-parties cookies for optimazing site functions and to enable use of maps.</p>
            <h4>What are your choices regarding cookies</h4>
            <p>If you'd like to delete cookies or instruct your web browser to delete or refuse cookies, please visit the help pages of your web browser. Please note, however, that if you delete cookies or refuse to accept them, you might not be able to use all of the features we offer, you may not be able to store your preferences, and some of our pages might not display properly.</p>
          </div>
        </div>
      )
    };
}